module.exports = __webpack_public_path__ + "static/media/personal_bundle.74120b6c.png";